import { render, staticRenderFns } from "./PurchaseInvoiceProfileForm.vue?vue&type=template&id=f5153c68&"
import script from "./PurchaseInvoiceProfileForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoiceProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports